<template lang="pug" src='./home.pug'></template>

<script>
import Hero from 'components/hero/hero'
import Loader from 'components/loader/loader'

import HomeQuote from 'components/custom/custom-home-quote/custom-home-quote'
import HomeTest from 'components/custom/custom-home-testimonials/custom-home-testimonials'
import HomeTiles from 'components/custom/custom-home-tiles/custom-home-tiles'
import HomeWelcome from 'components/custom/custom-home-welcome/custom-home-welcome'

import { trigger } from '@/methods'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  mixins: [ trigger ],
  components: {
    Hero,
    Loader,
    HomeQuote,
    HomeTest,
    HomeTiles,
    HomeWelcome
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?2d6424fe